const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

export const getSiteUrl = () => {
  const envUrl = process.env.REACT_APP_SITE_URL || "";
  if (envUrl) {
    return trimTrailingSlash(envUrl);
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return trimTrailingSlash(window.location.origin);
  }
  return "";
};

export const buildAbsoluteUrl = (value) => {
  if (!value) return "";
  if (value.startsWith("http://") || value.startsWith("https://")) {
    return value;
  }
  const siteUrl = getSiteUrl();
  if (!siteUrl) return value;
  const normalized = value.startsWith("/") ? value : `/${value}`;
  return `${siteUrl}${normalized}`;
};
